import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

export function usePopState() {
  const [isPopState, setIsPopState] = useState(false);
  const router = useRouter();

  useEffect(() => {
    router.beforePopState(({ options }) => {
      options.scroll = false;
      window.isPopState = true;
      return true;
    });
    setIsPopState(window.isPopState);

    return () => {
      window.isPopState = false;
    };
  }, []);

  return { isPopState };
}
